/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
/**
 * Represents a row within the table.
 */
export class TableRow {
    constructor(data, selected = false) {
        this.data = data;
        this.selected = selected;
    }
}
